export const TRANSIT_COLUMNS = [
  {
    title: "Cylinder NO.",
    sortArrow: true,
    sortBy: "number",
    address: ["cylinder_no"],
  },
  {
    title: "Dispatch Date",
    sortArrow: true,
    sortBy: "date",
    address: ["dispatched_date"],
  },
  {
    title: "Dispatched From Station",
    sortArrow: true,
    sortBy: "alphabetically",
    address: ["dispatched_from_station"],
  },
  {
    title: "Dispatch By",
    sortArrow: true,
    sortBy: "alphabetically",
    address: ["dispatched_by"],
  },
  {
    title: "Vehicle NO.",
    sortArrow: true,
    sortBy: "number",
    address: ["vehicle_no"],
  },
];

export const IDLE_CYLINDERS_COLUMNS = [
  {
    title: "Site/ID",
    sortArrow: true,
    sortBy: "alphabetically",
    address: ["stationName"],
  },
  {
    title: "Machine",
    sortArrow: true,
    sortBy: "alphabetically",
    address: ["machineId"],
  },
  {
    title: "Field Technician",
    sortArrow: true,
    sortBy: "alphabetically",
    address: ["jbccFtName"],
  },
    {
    title: "Supervisor",
    sortArrow: true,
    sortBy: "alphabetically",
    address: ["jbccSupName"],
  },
  {
    title: "Filled",
    sortArrow: true,
    sortBy: "number",
    address: ["filledCount"],
  },
  {
    title: "Empty",
    sortArrow: true,
    sortBy: "number",
    address: ["emptyCount"],
  },
  {
    title: "View",
  },
];
